<template>
    <div class="d-flex justify-content-between align-items-center gap-2 mb-3 flex-wrap flex-md-nowrap">
        <div class="flex-grow-0 flex-basis-50 d-flex justify-content-md-start order-1 order-md-1">
            <ButtonIcon v-if="button === 'goBack'" icon="chevron-left" variant="link" class="p-0 text-secondary text-nowrap font-weight-bolder" @click="$router.go(-1)">{{ $t('goBack') }}</ButtonIcon>
            <ButtonIcon v-if="button === 'goToPanel'" icon="log-in" variant="link" class="p-0 text-secondary text-nowrap font-weight-bolder" :to="{name: 'Dashboard', params: { role: userRoleShort }}">{{ $t('goToPanel') }}</ButtonIcon>
        </div>
        <div class="flex-grow-1 flex-basis-100 flex-basis-md-50 d-flex justify-content-center order-3 order-md-2">
            <img v-if="logo === 'buybox'" src="../../../../assets/logo-buybox.png" alt="BUY.BOX" class="height-40">
            <img v-if="logo === 'tipbox'" src="../../../../assets/logo-tipbox.png" alt="tip.BOX" class="height-40">
        </div>
        <div class="flex-grow-0 flex-basis-md-50 d-flex justify-content-md-end order-2 order-md-3">
            <span>{{ step }}</span>
        </div>
    </div>
</template>



<script>
    export default {
        name: 'Topbar',
        props: {
            button: {
                type: String,
                required: true,
                validator: val => ['goBack', 'goToPanel'].includes(val),
            },
            logo: {
                type: String,
                required: true,
                validator: val => ['buybox', 'tipbox'].includes(val),
            },
            step: {
                type: String,
                required: true,
            },
        },
        computed: {
            userRoleShort() {
                return this.$store.getters['auth/getRoleShortName'];
            },
        },
    };
</script>



<i18n lang="json" locale="pl" scope="local">
{
    "goBack": "Powrót",
    "goToPanel": "Przejdź do panelu"
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "goBack": "Go back",
    "goToPanel": "Go to panel"
}
</i18n>

